export const addCountryCode = (phoneNumber: string): string =>
  phoneNumber.startsWith("+1") ? phoneNumber : `+1${phoneNumber}`;

export const stripCountryCode = (phoneNumber: string): string =>
  phoneNumber.startsWith("+1") ? phoneNumber.slice(2) : phoneNumber;

export const formatPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/\D/g, "");

  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  } else if (cleaned.length === 11 && cleaned[0] === "1") {
    return cleaned.replace(/1(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  } else {
    return phoneNumber;
  }
};
